import InfoBlock from './views/InfoBlock';
export default InfoBlock;
